import React from 'react';
import './agencies.style.sass';
import {Col, Row} from 'rsuite';
import AgenciesListComponent from "../../components/agencies/agenciesList.component";
import IranMapComponent from "../../components/iranMap/iranMap.component";

const AgenciesLayout = () => {
    return (
        <div className='container'>
            <div className='agencies-page'>
                <Row>
                    <Col className='iran-container' md={12} xs={24}>
                        <IranMapComponent className='companis-svg' />
                    </Col>
                    <Col className='table-container' md={12} xs={24}>
                        <AgenciesListComponent />
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default AgenciesLayout;